import React, {useEffect} from "react";
import { useState } from "react";
import { getAllMasterFilterData } from "./LoadEquipmentService";
import EquipmentMainPage from "./EquipmentMainPage";
import { withApollo } from "react-apollo";
import { useSelector } from "react-redux";
import { DEFAULT_COLUMNS, DEFAULT_FILTER, DEFAULT_PAGE_SIZE } from "../../constants";
import { loadEquipmentGridColumns } from "../schema/helpers/equipmentGridColumns";
import { useContext } from "react";
import { CustomFilterContext } from "../booking-instruments/booking-instruments-custom-filter/context";
import {
  consumeBookEquipmentStartupReset,
  getBookEquipmentSessionPreferences,
  setBookEquipmentSessionPreferences,
} from "../../utils/store/bookingFilterPersistence";

const LoadEquipmentInfo = ({
  client,
  setEquipmentDetailList,
  isStepEnable,
  setNewEquipmentIds,
  setLimitExceedStatus,
  limitExceedStatus,
  landingPageAppSyncClient,
  paginationActions
}) => {
  const [masterDataFilters, setMasterDataFilters] = useState({});
  const [myLabFilter, setMyLabFilter] = useState(null);
  const [lastFavFilter, setLastFavFilter] = useState(DEFAULT_FILTER);
  const [userFilters, setUserFilters] = useState([]);
  const [userDisplayColumn, setUserDisplayColumn] = useState([]);
  const [lastDisplayColumns, setLastDisplayColumns] = useState(DEFAULT_COLUMNS());
  const [lastPageSize, setLastPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [megaClusterIDList, setMegaClusterIDList] = useState([]);
  const shouldResetBookEquipmentRef = React.useRef(consumeBookEquipmentStartupReset());
  const sessionPreferencesRef = React.useRef(getBookEquipmentSessionPreferences());

  const updateLastDisplayColumnDefinition = (parsedData) => {
    if (!parsedData?.displayDefinition) return
    try {
      const parsed =
        typeof lastDisplayColumns === "string"
          ? JSON.parse(lastDisplayColumns)
          : lastDisplayColumns;
      if (!parsed.displayDefinition) return

      const updated = {
        ...parsed,
        displayDefinition: parsedData.displayDefinition,
      };

      setLastDisplayColumns(JSON.stringify(updated));
    } catch (err) {
      console.error("Failed to update lastDisplayColumns:", err);
    }
  };

  const { setActiveTab, setSelectedCheckedRows } = useContext(CustomFilterContext);
  const storeUser = useSelector((store) => store.user);
  useEffect(() => {
    setSelectedCheckedRows([]);
    loadFilterMasterData();
    setActiveTab(0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadFilterMasterData = async () => {
    // Resolve the schema-derived columns before the grid renders. Until this settles, allTableColumn
    // and the listOf… constants answer from their hand-written fallbacks.
    await loadEquipmentGridColumns().catch((error) => {
      // Loud on purpose. A failure here is not cosmetic: allTableColumn() falls back to the
      // hand-written list, so every schema-only column silently disappears from the grid and the
      // columns tool panel. The fallback keeps the page usable, but the cause must be findable.
      // eslint-disable-next-line no-console
      console.error(
        "[schema] Could not derive grid columns; falling back to the hand-written list. " +
          "Schema-only columns (Description, Equipment type, …) will be missing.",
        error
      );
    });

    const { masterFiltersList, myLabFilterMaster, userDetail, userDisplayColumnMaster, megaClusterIds } =
      await getAllMasterFilterData({
        client: client,
        site: storeUser?.site,
        userID: storeUser?.id,
        cachedUser: storeUser
      });
    setMyLabFilter(() => myLabFilterMaster);
    setMasterDataFilters(() => masterFiltersList);
    setUserFilters(() => userDetail?.userFilters);
    setLastFavFilter(() => {
      if (sessionPreferencesRef.current?.lastFavFilter) {
        return sessionPreferencesRef.current.lastFavFilter;
      }

      return shouldResetBookEquipmentRef.current ? DEFAULT_FILTER : userDetail?.lastFavFilter;
    });
    setUserDisplayColumn(() => userDisplayColumnMaster);
    setLastDisplayColumns(() => {
      if (sessionPreferencesRef.current?.lastDisplayColumns) {
        return sessionPreferencesRef.current.lastDisplayColumns;
      }

      return shouldResetBookEquipmentRef.current ? DEFAULT_COLUMNS() : userDetail?.lastDisplayColumns;
    });
    setMegaClusterIDList(megaClusterIds);
    shouldResetBookEquipmentRef.current = false;
    sessionPreferencesRef.current = null;
  };

  useEffect(() => {
    setBookEquipmentSessionPreferences({
      lastFavFilter,
      lastDisplayColumns,
    });
  }, [lastFavFilter, lastDisplayColumns]);

  return (
    Object.keys(masterDataFilters)?.length > 0 && (
      <>
        <EquipmentMainPage
          masterDataFilters={masterDataFilters}
          myLabFilter={myLabFilter}
          lastFavFilter={lastFavFilter}
          setLastFavFilter={setLastFavFilter}
          userFilters={userFilters}
          setUserFilters={setUserFilters}
          userDisplayColumn={userDisplayColumn}
          setUserDisplayColumn={setUserDisplayColumn}
          lastDisplayColumns={lastDisplayColumns}
          setLastDisplayColumns={setLastDisplayColumns}
          updateLastDisplayColumnDefinition={updateLastDisplayColumnDefinition}
          lastPageSize={lastPageSize}
          setLastPageSize={setLastPageSize}
          megaClusterIDList={megaClusterIDList}
          setEquipmentDetailList={setEquipmentDetailList}
          isStepEnable={isStepEnable}
          setNewEquipmentIds={setNewEquipmentIds}
          setLimitExceedStatus={setLimitExceedStatus}
          limitExceedStatus={limitExceedStatus}
          landingPageAppSyncClient={landingPageAppSyncClient}
          reloadFilterData={loadFilterMasterData}
          paginationActions={paginationActions}
        />
      </>
    )
  );
};
export default withApollo(LoadEquipmentInfo);
